import MobileMenu from "./mobile/MobileMenu";
import DropDownMenuHandler from "./DropDownHandler";
export default class MenuHandler {
    private breakpoint: string;

    constructor() {
        this.breakpoint = "(max-width: 1280px)";
    }

    public init = async () => {
        const mobileMenu = new MobileMenu();
        const desktopDropDown = new DropDownMenuHandler();

        if (window.matchMedia(this.breakpoint).matches) {
            mobileMenu.init();
            desktopDropDown.destroy();
        } else {
            mobileMenu.destroy();
            desktopDropDown.init();
        }

        this.watcher(mobileMenu, desktopDropDown);
    };

    private watcher = (mobileMenu: MobileMenu, desktopDropDown: DropDownMenuHandler) => {
        window.matchMedia(this.breakpoint).addEventListener("change", (e) => {
            if (e.matches) {
                mobileMenu.init();
                desktopDropDown.destroy();
            } else {
                mobileMenu.destroy();
                desktopDropDown.init();
            }
        });
    };
}
